import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  requestsSearchResult: undefined,
  requestSidebar: {
    request: undefined,
    visible: false,
  },
  approversSearchResult: undefined,
  approverSidebar: {
    saveAction: undefined,
    visible: false,
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
